export const Search = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
      <g clipPath="url(#clip0_4761_60876)">
        <path
          d="M6.98984 11.0637C9.56177 11.0637 11.6467 8.97877 11.6467 6.40683C11.6467 3.83489 9.56177 1.75 6.98984 1.75C4.4179 1.75 2.33301 3.83489 2.33301 6.40683C2.33301 8.97877 4.4179 11.0637 6.98984 11.0637Z"
          fill="#5D6977"
          stroke="#5D6977"
          strokeWidth="1.09572"
          strokeLinejoin="round"
        />
        <path
          d="M8.53969 4.58347C8.33641 4.37968 8.09486 4.21806 7.82892 4.10792C7.56298 3.99777 7.2779 3.94127 6.99006 3.94165C6.70221 3.94127 6.41713 3.99777 6.15119 4.10792C5.88526 4.21806 5.64371 4.37968 5.44043 4.58347"
          fill="#5D6977"
        />
        <path
          d="M8.53969 4.58347C8.33641 4.37968 8.09486 4.21806 7.82892 4.10792C7.56299 3.99777 7.2779 3.94127 6.99006 3.94165C6.70221 3.94127 6.41713 3.99777 6.15119 4.10792C5.88526 4.21806 5.64371 4.37968 5.44043 4.58347"
          stroke="white"
          strokeWidth="1.09572"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path d="M10.3379 9.75513L12.6622 12.0794L10.3379 9.75513Z" fill="#5D6977" />
        <path d="M10.3379 9.75513L12.6622 12.0794" stroke="#5D6977" strokeWidth="1.09572" strokeLinecap="round" strokeLinejoin="round" />
      </g>
      <defs>
        <clipPath id="clip0_4761_60876">
          <rect width="14" height="14" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
